import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Footer from './components/Footer';
import { Provider } from 'react-redux';
import store from './store';
import Catalogue from './components/Catalogue';
import Login from './pages/Login';
import LockerAuth from './pages/LockerAuth';
import Signup from './pages/Signup';
import MonCompte from './pages/MonCompte';
import ForgotPassword1 from './pages/ForgotPassword1';
import ForgotPassword2 from './pages/ForgotPassword2';
import ForgotPassword3 from './pages/ForgotPassword3';
import { LangProvider } from './i18n';
import { AuthProvider } from './contexts/AuthContext';

const App: React.FC = () => {
  return (
    <LangProvider>
      <AuthProvider>
        <Provider store={store}>
          <BrowserRouter>
            <div className="App">
              <Routes>
                <Route path="/" element={<Catalogue />} />
                <Route path="/login" element={<Login onLogin={() => {}} />} />
                <Route path="/mon-compte" element={<MonCompte />} />
                <Route path="/creer-compte" element={<LockerAuth onSuccess={() => window.location.replace('/signup')} />} />
                <Route path="/signup" element={<Signup onSuccess={() => window.location.replace('/login')} />} />
                <Route path="/forgot-password-1" element={<ForgotPassword1 />} />
                <Route path="/forgot-password-2" element={<ForgotPassword2 />} />
                <Route path="/forgot-password-3" element={<ForgotPassword3 />} />
              </Routes>
              <Footer />
            </div>
          </BrowserRouter>
        </Provider>
      </AuthProvider>
    </LangProvider>
  );
};

export default App;
